import Api from "@/api";
const route = "gfs/processes";

const index = async (query) => {
  const result = await Api.query(`v1/${route}`, query);
  return result.data;
};

const processTypes = async (query) => {
  const result = await Api.query(`v1/${route}/process-types`, query);
  return result.data;
};

const processStatus = async (query) => {
  const result = await Api.query(`v1/${route}/process-status`, query);
  return result.data;
};

const processDepartaments = async (query) => {
  const result = await Api.query(`v1/${route}/departaments`, query);
  return result.data;
};

const pendingProcesses = async (query) => {
  const result = await Api.query(`v1/${route}/process-pending`, query);
  return result.data;
}

export default {
  index,
  processTypes,
  processStatus,
  processDepartaments,
  pendingProcesses
};
